var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Email_16x16",
    "data-name": "Icon Email 16x16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Mail_16x16",
    "data-name": "Icon Mail 16x16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Grid_Box_32x32",
    "data-name": "Grid Box 32x32",
    width: 16,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Paths",
    transform: "translate(0.875 2.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_41",
    "data-name": "Union 41",
    d: "M1.125,10.584A1.127,1.127,0,0,1,0,9.458V1.126A1.129,1.129,0,0,1,1.125,0h12a1.128,1.128,0,0,1,1.126,1.126V9.458a1.126,1.126,0,0,1-1.126,1.125Zm.128-1.625a.377.377,0,0,0,.374.376h11A.377.377,0,0,0,13,8.959V2.815L7.359,6.232a.428.428,0,0,1-.469,0L1.253,2.911Zm.058-7.535,5.716,3.4a.182.182,0,0,0,.2,0h0l5.713-3.4a.377.377,0,0,0-.318-.173h-11A.37.37,0,0,0,1.311,1.424Z",
    fill: "#1d1d1b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.64ab07c11b6a3533180ca1fcb21f519f.svg";
export { ForwardRef as ReactComponent };